import axios from 'axios';
// import { Message } from 'element-ui';

axios.defaults.timeout = 5000;
axios.defaults.baseURL = 'http://api.mofangtour.com/';
//axios.defaults.baseURL ='http://192.168.100.2:8010';
axios.defaults.headers["Content-Type"] = "application/json";
// axios.defaults.headers["dataType"] = "jsonp";
// dataType: "jsonp",
axios.defaults.withCredential = true
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest',
// axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";

//http request 拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        // let fixedContent = {
        //     user_id: window.sessionStorage.getItem("user_id"),
        //     token: window.sessionStorage.getItem("token"),
        // }
        // if (!fixedContent.user_id || !fixedContent.token) {
        //     // alert('登录过期')
        //     return false
        // }
        // params = {
        //     ...fixedContent,
        //     ...params
        // }
        axios.get(url, {
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}
export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        // let fixedContent = {
        //     // user_id: window.sessionStorage.getItem("user_id"),
        //     // token: window.sessionStorage.getItem("token")
        //     user_id: "10",
        //     token: "8cf8a4ea3e15f731dcd03c7ae0a83a8b"
        // }
        // if (!fixedContent.user_id || !fixedContent.token) {
        //     // alert('登录过期')
        //     return false
        // }
        // data = {
        //     ...fixedContent,
        //     ...data
        // }
        axios.post(url, data).then(function (response) {
            resolve(response.data);
        }).catch(function (error) {
            reject(error)
        });
    })
}
